import { type FC, useMemo } from 'react';
import { GalleryAutoWidth } from '@direct-frontend/components';
import { ShowMoreItem, type ShowMoreItemProps } from './components/ShowMoreItem/ShowMoreItem';
import { CardsGalleryItem, type ProductCardForGallery } from '../CardsGalleryItem';
import styles from './CardsGalleryCards.module.css';

export type CardsGalleryCardsProps = {
    items: ProductCardForGallery[];
    showMore?: {
        show: ShowMoreItemProps['show'];
        totalString: ShowMoreItemProps['totalString'];
        howMuchLonger: ShowMoreItemProps['howMuchLonger'];
        onClick: ShowMoreItemProps['onClick'];
    };
};

const ID_SHOW_MORE = '--show-more--';

export const CardsGalleryCards: FC<CardsGalleryCardsProps> = ({ items, showMore }) => {
    const itemsWithShowMore = useMemo<ProductCardForGallery[]>(
        () => (showMore?.show ? [...items, { id: ID_SHOW_MORE, name: showMore.totalString, priceFrom: 0 }] : items),
        [items, showMore]
    );

    if (items.length === 0) {
        return null;
    }

    return (
        <GalleryAutoWidth<ProductCardForGallery>
            animationDuration={300}
            itemGapSize="8"
            items={itemsWithShowMore}
            arrowButtons={{ className: styles.arrowButton }}
            renderItemContent={(props) => {
                if (props.id === ID_SHOW_MORE) {
                    if (showMore?.show) {
                        return (
                            <ShowMoreItem
                                show={showMore.show}
                                totalString={showMore.totalString}
                                howMuchLonger={showMore.howMuchLonger}
                                onClick={showMore.onClick}
                            />
                        );
                    }

                    return null;
                }

                return <CardsGalleryItem {...props} />;
            }}
        />
    );
};
